'use client';
import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';

/**
 * BL-395: sends a Klaviyo "Viewed Page" event on the initial load and on every
 * client-side route change, replacing the ODP `pageview` (Uma on the ticket,
 * 6 Oct). Klaviyo drops browser events from anonymous visitors, so these are
 * only recorded once the visitor is identified (Klaviyo email, Klaviyo form,
 * or our newsletter / Save for Later, see identifyVisitor).
 *
 * Pushed to `_klOnsite` like OpenKlaviyoForm: the onsite script drains the
 * queue when it loads, which also covers Osano holding it until consent.
 */
export default function KlaviyoPageView() {
  const pathname = usePathname();
  const lastPathRef = useRef(null);

  useEffect(() => {
    // Without the key KlaviyoScript never loads the onsite script, so nothing
    // would ever drain the queue.
    if (!process.env.NEXT_PUBLIC_KLAVIYO_PUBLIC_API_KEY) return;
    if (lastPathRef.current === pathname) return;
    lastPathRef.current = pathname;

    // `page` and `url` are pinned because the queue can drain after the next
    // navigation.
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push([
      'track',
      'Viewed Page',
      { page: pathname, url: window.location.href },
    ]);
  }, [pathname]);

  return null;
}
